/* ==========================================================================
   Product page upgrade — 2026-10-05
   Loaded (deferred) by sections/ip-pdp-foot.liquid. Styles: ip-pdp-v2.css.

   Adds three things to the product page built by
   sections/ipl-product-page.liquid, without touching that file:
     1. A buy bar pinned to the bottom of wide screens while the main
        Add to basket button is out of view. It never adds to the basket
        itself: its button presses the real one, so stock rules, quantity and
        the selected option are always the page's own.
     2. Jump links in that bar to the description, specification, FAQs and
        reviews, when the page has them.
     3. Swipe left / right on the main photo, and a "2 / 5" photo counter.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.getElementById('iplp');
  if (!root) { return; }

  var atc = document.getElementById('iplpAtc');
  var buy = root.querySelector('.iplp__buy');
  var stage = root.querySelector('.iplp__stage');
  var allThumbs = Array.prototype.slice.call(root.querySelectorAll('.iplp__thumb'));

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) { node.className = cls; }
    if (text != null) { node.textContent = text; }
    return node;
  }

  /* Other scripts hide the photos that belong to a colour that is not
     selected, so "the photos" always means the ones currently on show. */
  function thumbs() {
    return allThumbs.filter(function (thumb) { return !thumb.hidden && thumb.style.display !== 'none'; });
  }

  function activeIndex(list) {
    for (var i = 0; i < list.length; i++) { if (list[i].classList.contains('active')) { return i; } }
    return 0;
  }

  function activeThumb() {
    var list = thumbs();
    return list.length ? list[activeIndex(list)] : null;
  }

  /* --- 3. Photo counter + swipe ------------------------------------------ */
  var count = null;
  function paintCount() {
    if (!count) { return; }
    var list = thumbs();
    count.hidden = list.length < 2;
    count.textContent = (activeIndex(list) + 1) + ' / ' + list.length;
  }

  if (stage && allThumbs.length > 1) {
    count = el('span', 'ipv2-count');
    count.setAttribute('aria-hidden', 'true');
    stage.appendChild(count);
    paintCount();

    var startX = null;
    var startY = null;
    stage.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1) { startX = null; return; }
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchend', function (event) {
      if (startX === null || !event.changedTouches.length) { return; }
      var dx = event.changedTouches[0].clientX - startX;
      var dy = event.changedTouches[0].clientY - startY;
      startX = null;
      if (Math.abs(dx) < 44 || Math.abs(dx) < Math.abs(dy) * 1.5) { return; }
      var list = thumbs();
      var next = activeIndex(list) + (dx < 0 ? 1 : -1);
      if (next < 0 || next >= list.length) { return; }
      list[next].click();
      if (list[next].scrollIntoView) { list[next].scrollIntoView({ block: 'nearest', inline: 'nearest' }); }
    }, { passive: true });
  }

  var thumbBox = document.getElementById('iplpThumbs');
  if (thumbBox) {
    new MutationObserver(function () { window.setTimeout(paintCount, 0); })
      .observe(thumbBox, { subtree: true, attributes: true, attributeFilter: ['class', 'hidden', 'style'] });
  }

  /* --- 1. Buy bar --------------------------------------------------------- */
  if (!atc || !buy) { return; }

  var bar = el('div', 'ipv2-bar');
  bar.id = 'ipv2Bar';
  bar.setAttribute('role', 'region');
  bar.setAttribute('aria-label', 'Buy this product');
  var inner = el('div', 'ipv2-bar__in');
  var img = el('img', 'ipv2-bar__img');
  img.alt = '';
  img.width = 52;
  img.height = 52;
  var txt = el('div', 'ipv2-bar__txt');
  var titleEl = root.querySelector('.iplp__title');
  var title = el('span', 'ipv2-bar__title', titleEl ? titleEl.textContent.trim() : document.title);
  var variant = el('span', 'ipv2-bar__var');
  txt.appendChild(title);
  txt.appendChild(variant);
  var nav = el('div', 'ipv2-bar__nav');
  var price = el('div', 'ipv2-bar__price');
  var priceMain = el('b');
  var priceSub = el('span');
  price.appendChild(priceMain);
  price.appendChild(priceSub);
  var button = el('button', 'ipv2-bar__atc', 'Add to basket');
  button.type = 'button';
  inner.appendChild(img);
  inner.appendChild(txt);
  inner.appendChild(nav);
  inner.appendChild(price);
  inner.appendChild(button);
  bar.appendChild(inner);
  document.body.appendChild(bar);

  button.addEventListener('click', function () { atc.click(); });

  function selection() {
    var parts = [];
    Array.prototype.forEach.call(root.querySelectorAll('.iplp__opt'), function (opt) {
      var select = opt.querySelector('[data-optselect]');
      var pill = opt.querySelector('.iplp__pills > [data-optpill].active');
      var value = select ? select.value : (pill ? pill.getAttribute('data-value') : '');
      if (value) { parts.push(value.replace(/\s+/g, ' ').trim()); }
    });
    return parts.join(' · ');
  }

  function sync() {
    var mainPrice = document.getElementById('iplpBuyPrice');
    var extras = document.getElementById('iplpPriceExtras');
    var stock = document.getElementById('iplpStock');
    var thumb = activeThumb();
    var thumbImg = thumb ? thumb.querySelector('img') : null;
    var mainImg = document.getElementById('iplpMain');
    var src = thumbImg ? thumbImg.getAttribute('src') : (mainImg ? mainImg.getAttribute('src') : '');
    if (src && img.getAttribute('src') !== src) { img.setAttribute('src', src); }
    priceMain.textContent = mainPrice ? mainPrice.textContent.trim() : '';
    var sub = (extras && !extras.hidden) ? extras.textContent.trim() : '';
    priceSub.textContent = sub || (stock ? stock.textContent.trim() : '');
    variant.textContent = selection() || (stock ? stock.textContent.trim() : '');
    button.disabled = atc.disabled;
    button.textContent = atc.textContent.trim() || 'Add to basket';
  }

  var syncTimer = null;
  function queue() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(sync, 30);
  }

  new MutationObserver(queue).observe(buy, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled', 'hidden'] });
  if (thumbBox) { thumbBox.addEventListener('click', queue); }
  sync();

  /* Shown whenever the real button is off screen, above or below. Measured on
     scroll rather than with an IntersectionObserver so the first state is
     right before the first frame, and it costs one rectangle read. */
  var isOn = null;
  function toggle() {
    var rect = atc.getBoundingClientRect();
    var viewport = window.innerHeight || document.documentElement.clientHeight;
    var on = rect.width > 0 && (rect.bottom < 60 || rect.top > viewport - 20);
    if (on === isOn) { return; }
    isOn = on;
    bar.classList.toggle('is-on', on);
    document.documentElement.classList.toggle('ipv2-bar-on', on);
  }

  window.addEventListener('scroll', toggle, { passive: true });
  window.addEventListener('resize', toggle);
  window.addEventListener('load', toggle);
  toggle();

  /* --- 2. Jump links ------------------------------------------------------
     Descriptions are free-form, so the specification and FAQ are found by
     their heading text, at whatever heading level the page used. */
  function addLink(label, target) {
    var link = el('button', null, label);
    link.type = 'button';
    link.addEventListener('click', function () {
      var holder = target.closest ? target.closest('details') : null;
      if (holder) { holder.open = true; }
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });
    nav.appendChild(link);
  }

  var acc = document.getElementById('iplpAcc');
  var heads = acc ? Array.prototype.slice.call(acc.querySelectorAll('summary, h2, h3, h4, h5')) : [];
  function find(pattern) {
    for (var i = 0; i < heads.length; i++) { if (pattern.test(heads[i].textContent)) { return heads[i]; } }
    return null;
  }

  if (acc && acc.firstElementChild) { addLink('Description', acc); }
  var spec = find(/specification|technical data|data ?sheet|properties/i);
  if (spec) { addLink('Specification', spec); }
  var faq = find(/faq|frequently asked|questions/i);
  if (faq) { addLink('FAQs', faq); }

  /* Reviews load late and their section is hidden while empty, so the link is
     only added once there is something to jump to. */
  var tries = 0;
  (function reviews() {
    var widget = document.getElementById('looxReviews');
    if (widget && widget.getBoundingClientRect().height > 40) { addLink('Reviews', widget); return; }
    if (++tries < 8) { window.setTimeout(reviews, 1500); }
  })();
})();
